import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_AMBER } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/cradles.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Cradles — Sub Urban (NCS). Mid-tier melody-led pop with a strong
 * vocal hook. 80 BPM and steady phrasing make it a comfortable Hard /
 * Extreme stress test once players have cleared the easier tier.
 *
 * Synthesised from the existing Circles onset analysis — see header
 * doc on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const CRADLES_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'cradles',
  baseTitle: 'Cradles',
  description:
    "Sub Urban's dark alt-pop. Snappy snares and vocal-led groove walk the lanes left-to-right.",
  difficulty: 3,
  totalBeats: 83,
  palette: PALETTE_AMBER,
  audio: buildBuiltinAudio({
    src: '/audio/circles/cradles.mp3',
    attribution: '"Cradles" by Sub Urban [NCS Release] - https://ncs.io/Cradles',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 83,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.06, minSpacing: 0.5 },
    },
  ],
});
